import axios from "axios";
import config from "../config/app/config";

// For common config
axios.defaults.headers.post["Content-Type"] = "application/json";

const backend = axios.create({
  baseURL: config["server-host"],
});

export default backend;
